import { RouterChild } from '@/router';

export default [
  { name: 'admin-employees', path: 'employees', component: () => import('./views/Overview.vue') } as RouterChild
];
